var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletetrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2936_1235",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2936_1235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6155 20C7.168 20 6.78683 19.8426 6.472 19.528C6.15733 19.2131 6 18.832 6 18.3845V5.99996H5V4.99996H9V4.23071H15V4.99996H19V5.99996H18V18.3845C18 18.8448 17.8458 19.2291 17.5375 19.5375C17.2292 19.8458 16.8448 20 16.3845 20H7.6155ZM17 5.99996H7V18.3845C7 18.564 7.05767 18.7115 7.173 18.827C7.2885 18.9423 7.436 19 7.6155 19H16.3845C16.5385 19 16.6796 18.9359 16.8077 18.8077C16.9359 18.6795 17 18.5385 17 18.3845V5.99996ZM9.80775 17H10.8078V7.99996H9.80775V17ZM13.1923 17H14.1923V7.99996H13.1923V17Z",
    fill: "#2C357D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletetrash);
export default __webpack_public_path__ + "static/media/deletetrash.2f0c2652ef9c09beb67904abbb7bb1e6.svg";
export { ForwardRef as ReactComponent };